import { render, staticRenderFns } from "./MicroCreditFileForm.vue?vue&type=template&id=2b473e41&"
import script from "./MicroCreditFileForm.vue?vue&type=script&lang=js&"
export * from "./MicroCreditFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports